import { render } from "./component-termination-reason.vue?vue&type=template&id=41472bcc"
import script from "./component-termination-reason.vue?vue&type=script&setup=true&lang=js"
export * from "./component-termination-reason.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-termination-reason.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41472bcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41472bcc', __exports__)) {
    api.reload('41472bcc', __exports__)
  }
  
  module.hot.accept("./component-termination-reason.vue?vue&type=template&id=41472bcc", () => {
    api.rerender('41472bcc', render)
  })

}


export default __exports__